import { Divider, Flex, Text, VStack } from '@chakra-ui/react'
import { PropsWithChildren } from 'react'

const SearchTipSection = ({
  title,
  examples,
  prefix,
}: {
  title: string
  examples: string[]
  prefix?: string
}) => (
  <Flex px={1} w="100%" py={0.5} align="center" gap={1.5}>
    {prefix ? (
      <Text
        bg="blue.100"
        color="blue.600"
        fontWeight={600}
        fontSize="sm"
        px={1}
        boxShadow="1px 1px 3px rgba(0, 0, 0, 0.3)"
        borderRadius={3}>
        {prefix}:
      </Text>
    ) : null}
    <Text>{title}</Text>
    <Flex ml="auto" align="center" gap={1}>
      {examples.map(example => (
        <Text
          borderRadius={3}
          key={example}
          border="1px solid #cdcdcd"
          fontSize="sm"
          fontWeight={500}
          px={1.5}
          color="gray.600">
          {example}
        </Text>
      ))}
    </Flex>
  </Flex>
)

const EmailSearchTipSection = () => (
  <SearchTipSection title="Email" examples={['info@hamiltonbilling.com']} />
)

const PhoneSearchTipSection = () => (
  <SearchTipSection
    title="Phone Number"
    examples={['1234567890', '123-456-7890', '(123) 456-7890']}
  />
)

const PatientNameSearchTipSection = () => (
  <SearchTipSection
    title="Patient Name"
    examples={['Katie', 'Baker', 'Katie Baker', 'Baker Katie']}
  />
)
const DobSearchTipSection = () => <SearchTipSection title="DOB" examples={['MM/DD/YYYY']} />

const AuthRefSearchTipSection = () => (
  <SearchTipSection title="Auth Ref #" prefix="auth" examples={['auth:12345678']} />
)
const ClaimRefSearchTipSection = () => (
  <SearchTipSection title="Claim Ref #" prefix="claim" examples={['claim:12345678']} />
)
const CheckRefSearchTipSection = () => (
  <SearchTipSection title="Check/EFT Ref #" prefix="$" examples={['$:12345678']} />
)

const NextActionSearchTipSection = () => (
  <SearchTipSection title="Next Actions" prefix="na" examples={['na:01/01/2025']} />
)
const DeepSearchTipSection = () => (
  <SearchTipSection title="Deep search" prefix="deep" examples={['deep:katie baker']} />
)

const SearchTipHeader = () => (
  <Flex px={1} pb={1} w="100%" justify="space-between" align="center">
    <Text py={0.5} fontSize="sm" color="gray.600" fontWeight={600}>
      Search for:
    </Text>
    <Text py={0.5} fontSize="sm" color="gray.600" fontWeight={600}>
      Examples
    </Text>
  </Flex>
)

const SearchTipContainer = ({ children }: PropsWithChildren) => (
  <VStack align="flex-start" spacing={0} divider={<Divider />} flexFlow="column" w="100%">
    <SearchTipHeader />
    {children}
  </VStack>
)

export const AssessmentSearchTip = () => (
  <SearchTipContainer>
    <PatientNameSearchTipSection />
    <DobSearchTipSection />
    <PhoneSearchTipSection />
    <EmailSearchTipSection />
    <AuthRefSearchTipSection />
    <ClaimRefSearchTipSection />
    <CheckRefSearchTipSection />
    <NextActionSearchTipSection />
    <DeepSearchTipSection />
  </SearchTipContainer>
)

export const PatientSearchTip = () => (
  <SearchTipContainer>
    <PatientNameSearchTipSection />
    <DobSearchTipSection />
    <PhoneSearchTipSection />
    <EmailSearchTipSection />
    <DeepSearchTipSection />
  </SearchTipContainer>
)

export const PracticeAssessmentSearchTip = () => (
  <SearchTipContainer>
    <PatientNameSearchTipSection />
    <DobSearchTipSection />
    <PhoneSearchTipSection />
    <EmailSearchTipSection />
    <CheckRefSearchTipSection />
    <NextActionSearchTipSection />
    <DeepSearchTipSection />
  </SearchTipContainer>
)
